module.exports = __webpack_public_path__ + "img/error.e098a499.png";